import { AuthContext, FireactContext, SetPageTitle } from "../lib/core";
import { Box, Button, Card, CardContent, Container, Grid, Typography, Divider } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../template/Footer";
import OpacityIcon from '@mui/icons-material/Opacity';
import ScheduleIcon from '@mui/icons-material/Schedule';
import VerifiedIcon from '@mui/icons-material/VerifiedUser';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import "./About.css";

const IosApp = ({loader}) => {

    const { authInstance, authUser } = useContext(AuthContext);
    const { config } = useContext(FireactContext);
    const navigate = useNavigate();
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState(null);
    const [processing, setProcessing] = useState(false);

    useEffect(() => {
        setLoaded(false);
        setError(null);
        setLoaded(true);
    },[authInstance, config.saas.permissions]);

    return (
        <>
            {loaded ? (
                <Container maxWidth={false} disableGutters>
                    <SetPageTitle title="iOS App" />

                    <Box className="about-hero">
                        <Container>
                            <Grid container spacing={2} alignItems="center">
                                <Grid item xs={12} md={7}>
                                    <Typography variant="h2" className="hero-title">Living Waters iOS App</Typography>
                                    <Typography variant="h6" color="text.secondary" className="hero-sub">
                                        Our iOS app is coming soon! Experience the convenience of booking IV therapy on the go with our mobile app.
                                    </Typography>
                                    <Box sx={{ mt: 3 }}>
                                        { (authUser?.user === null) && (
                                            <Button variant="contained" color="primary" sx={{ mr: 2 }} onClick={() => navigate('/sign-in')}>Get Started</Button>
                                        ) }
                                        <Button variant="outlined" color="secondary" onClick={() => navigate('/contact')}>Contact Us</Button>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} md={5}>
                                    <Box className="hero-art">
                                        <PhoneIphoneIcon sx={{ fontSize: 120, color: 'primary.main' }} />
                                    </Box>
                                </Grid>
                            </Grid>
                        </Container>
                    </Box>

                    <Container sx={{ py: 6 }}>
                        <Grid container spacing={4}>
                            <Grid item xs={12} md={4}>
                                <Card className="feature-card">
                                    <CardContent>
                                        <SupportAgentIcon className="feature-icon" />
                                        <Typography variant="h6" gutterBottom>Easy Booking</Typography>
                                        <Typography color="text.secondary">Book IV therapy sessions directly from your iPhone with our intuitive app interface.</Typography>
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <Card className="feature-card">
                                    <CardContent>
                                        <VerifiedIcon className="feature-icon" />
                                        <Typography variant="h6" gutterBottom>Real-Time Updates</Typography>
                                        <Typography color="text.secondary">Get instant notifications about your appointments, nurse arrivals, and session progress.</Typography>
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <Card className="feature-card">
                                    <CardContent>
                                        <ScheduleIcon className="feature-icon" />
                                        <Typography variant="h6" gutterBottom>Flexible Scheduling</Typography>
                                        <Typography color="text.secondary">Schedule sessions at your convenience with our mobile scheduling tools.</Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>

                        <Divider sx={{ my: 6 }} />

                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <Typography variant="h5" gutterBottom>Coming Soon</Typography>
                                <Typography color="text.secondary">We're working hard to bring you the best mobile experience for IV therapy. Stay tuned for updates!</Typography>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography variant="h5" gutterBottom>App Features</Typography>
                                <ul className="why-list">
                                    <li>Seamless booking and scheduling</li>
                                    <li>Real-time tracking of your sessions</li>
                                    <li>Secure payment processing</li>
                                    <li>Direct communication with nurses</li>
                                </ul>
                            </Grid>
                        </Grid>
                    </Container>

                    <Footer />
                </Container>
            ) : (
                <>{loader}</>
            )}
        </>
    )
}

export default IosApp;